export const DATE_TIME_FORMAT = "YYYY-MM-DD hh:mm:ss a";

// Date after the understocked vmProductTransaction are requested to the backend.
export const START_DATE = "2019-07-04T00:00:00-0500";
